import {
  ActionCartAddProduct,
  ActionCartRemoveProduct,
  ActionRemoveDiscount,
} from "@store/cart";
import { ActionSearchProducts } from "@store/catalog";
import { AppState } from "@store/state";
import { BasePage } from "src/app/base";
import { Constants } from "@app/env";
import { ModalController } from "@ionic/angular";
import { Router } from "@angular/router";
import { Store } from "@ngrx/store";
import { take } from "rxjs/operators";
import {
  Component,
  Injector,
  OnInit,
  Output,
  EventEmitter,
} from "@angular/core";
import { Product, SaleItem } from "@tendercuts/models";

/**
 * to display the carry bag option in payment page
 */
@Component({
  selector: "app-carry-bag",
  templateUrl: "./carry-bag.component.html",
  styleUrls: ["./carry-bag.component.scss"],
})
export class CarryBagComponent extends BasePage implements OnInit {
  // when we select the carry bag option,emit the event

  @Output() bag: EventEmitter<any> = new EventEmitter<any>();

  //  when add carry bag option is select we set the value true to this variable
  isCarryBagSelect: boolean;

  // carry bag rupees
  rupee = 5;
  carryBag: Product;

  constructor(
    public store: Store<AppState>,
    private constants: Constants,
    public modalCtrl: ModalController,
    public router: Router,
    public injector: Injector
  ) {
    super(injector);
  }

  ngOnInit() {
    this.loadCarryBag();
    this.store
      .select((state) => state.cartState.quote.cartProducts)
      .pipe(take(1))
      .subscribe((state) => {
        this.isCarryBagSelect = state.some(
          (item) => item.productId === +this.constants.CARRYBAG.id
        );
      });
  }

  /**
   * it is used to fetch the carrybag product
   */
  async loadCarryBag() {
    this.store.dispatch(new ActionSearchProducts(this.constants.CARRYBAG.id));
    const catalogState = await this.store
      .select((appState) => appState.catalogState)
      .pipe(take(1))
      .toPromise();
    this.carryBag = catalogState.filteredProducts[0];
  }

  /**
   * when ngOnInit loads we call the checkCarryBagSelect() function
   * if carry bag not in cart
   * we allow the carry bag to add cart
   * if carry bad already in cart we just ignore the request
   */
  async addCarryBagtoCart() {
    let cartProducts: SaleItem[] = await this.store
      .select((state) => state.cartState.quote.cartProducts)
      .pipe(take(1))
      .toPromise();
    if (
      !cartProducts.some(
        (item: SaleItem) => item.productId === +this.constants.CARRYBAG.id
      )
    ) {
      this.store.dispatch(new ActionRemoveDiscount());
      this.store.dispatch(new ActionCartAddProduct(this.carryBag, 1));
      this.bag.emit();
    }
  }

  /**
   * check the cart state if carry bag is exist
   * remove the cart from product
   * if carry not exit we emit the event emiter
   */
  async removeCarryBag() {
    this.store.dispatch(new ActionRemoveDiscount());
    let cartProducts: SaleItem[] = await this.store
      .select((state) => state.cartState.quote.cartProducts)
      .pipe(take(1))
      .toPromise();
    if (
      cartProducts.some(
        (item: SaleItem) => item.productId === +this.constants.CARRYBAG.id
      )
    ) {
      this.store.dispatch(new ActionCartRemoveProduct(this.carryBag));
      this.bag.emit();
      return;
    }
    this.bag.emit();
  }
}
